import { render, staticRenderFns } from "./MitActionEditPersonPage.vue?vue&type=template&id=142728ec&scoped=true"
import script from "./MitActionEditPersonPage.vue?vue&type=script&lang=js"
export * from "./MitActionEditPersonPage.vue?vue&type=script&lang=js"
import style0 from "./MitActionEditPersonPage.vue?vue&type=style&index=0&id=142728ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142728ec",
  null
  
)

export default component.exports